import { render } from "./ResetPW.vue?vue&type=template&id=54e6f9db&scoped=true"
import script from "./ResetPW.vue?vue&type=script&lang=js"
export * from "./ResetPW.vue?vue&type=script&lang=js"

import "./ResetPW.vue?vue&type=style&index=0&id=54e6f9db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e6f9db"]])

export default __exports__